import {TransUnionEnquiry} from './TransUnionEnquiry';

export class TransUnionEnquiryList {
  public transUnionEnquiry: TransUnionEnquiry[];
}
